<template>
    <q-card flat bordered style="border: none; font-size: 2.16vmin">
        <q-card-actions>
            <div
                class="row align-center"
                style="width: 100%"
                :onClick="
                    () => {
                        expanded = !expanded;
                    }
                "
            >
                <div class="col-2 b2 color_gray_600 line_height_42 txt_left" style="width: 8.6vw">{{ props?.category }}</div>
                <div class="col flex justify-between align-center">
                    <div class="b2 line_height_42 txt_left" style="overflow: hidden; max-width: 68vw; padding: 0 0.6vw; white-space: nowrap; text-overflow: ellipsis">
                        {{ props?.title }}
                    </div>
                    <div class="txt_right" style="width: 5vw">
                        <q-icon :name="expanded ? 'img:/assets/images/icon/ico_up.svg' : 'img:/assets/images/icon/ico_down.svg'" style="width: 2.4vw; height: 2.4vw" />
                    </div>
                </div>
            </div>
        </q-card-actions>
        <q-slide-transition>
            <div v-show="expanded">
                <q-separator />
                <q-card-section>
                    <div
                        class="row"
                        style="width: 100%"
                        :onClick="
                            () => {
                                expanded = !expanded;
                            }
                        "
                    >
                        <div class="col-2" style="width: 8.6vw"></div>
                        <div class="col">
                            <div class="b3 conHtml" style="padding: 0 calc(0.6vw + 5vw) 0 0.6vw; line-height: 2vw" v-html="props?.contents" />
                        </div>
                    </div>
                </q-card-section>
                <div v-if="props.isLast" style="height: 5.6vh"></div>
            </div>
        </q-slide-transition>
    </q-card>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue';
const expanded = ref(false);
const props = defineProps({
    title: { default: null },
    category: { default: null },
    contents: { default: null },
    isLast: { default: false },
});
onMounted(() => {
    // console.log('Accordion props', props);
});
</script>

<style scoped lang="scss">
.title {
    color: #222222;
    font-size: 2.1vmin;
    font-weight: 700;
    margin: 2.5vmin 0 2.5vmin;
}

::v-deep {
    .conHtml {
        // overflow: hidden;
        * {
            img {
                width: 100%;
            }
        }
    }

    p {
        margin-bottom: 0;
    }
    .q-card__actions {
        margin: 1.42vmin 0;

        .q-icon {
            cursor: pointer;
        }
    }
    .q-card__section--vert {
        padding: 2.67vmin 0;
        background: $color_gray_100;
    }
}
.align-center {
    align-items: center;
}
</style>
